import _ from 'underscore';

import BaseView from '../log-base/view';
import template from './list/template.html';
import Suggest from '../suggest/index';

export default BaseView.extend({
	// use other template than base
	template: _.template(template),

	// extend base events
	events: _.extend({}, BaseView.prototype.events, {
		'change input[name="handled"]': 'onCheckboxChange'
	}),

	// override
	initialize: function() {
		// call BaseView constructor
		BaseView.prototype.initialize.call(this, arguments);

		this.instrumentSuggestView = new Suggest.Views.Main({
			el: '.js-instrument',
			dataUrl: '/autocomplete'
		}).render();
	},

	/**
	 * Handled checkbox changed handler
	 * see log-base/model.js
	 **/
	onCheckboxChange: function(e) {
		var checkbox = e.currentTarget,
			checked = checkbox.checked,
			modelId = checkbox.getAttribute('data-id'),
			model = this.collection.get(modelId);

		model.set('Handled', checked);
	},

	/**
	 * override
	 * clear instrument field as well
	 * then call base method
	 **/
	onFormReset: function(e) {
		// clear suggest
		this.instrumentSuggestView.clear();

		// call base method
		BaseView.prototype.onFormReset.apply(this, [e]);
	}
});
